import { gql, useQuery } from '@apollo/client';
import type { Person } from '@domain/person';

interface PersonQueryVars {
  idnumber: string;
}

const personQuery = gql`
  query ($idnumber: String!) {
    person(idnumber: $idnumber) {
      idnumber
      darn
      firstname
      surname
      position
      flags
      authn {
        cellnumber
        email
        emails {
          email
          isVerified
        }
        lastLogin
        createdAt
        suspended
        suspensionDetails {
          reason
          adminUser {
            idnumber
            darn
            firstname
            surname
            position
            flags
          }
          timestamp
        }
        adminChanges {
          adminUser {
            idnumber
            darn
            firstname
            surname
            position
            flags
          }
          reason
          fromNumber
          toNumber
          timestamp
        }
      }
    }
  }
`;

interface PersonQuery {
  person: Person;
}

interface UsePersonReturns {
  person?: Person;
  loading: boolean;
  refetch: () => Promise<void>;
}

export function usePerson(idnumber: string): UsePersonReturns {
  const { error, loading, data, refetch } = useQuery<
    PersonQuery,
    PersonQueryVars
  >(personQuery, { variables: { idnumber }, fetchPolicy: 'cache-and-network' });
  if (error != null) throw error;
  return {
    person: data?.person,
    loading,
    refetch: async () => {
      await refetch();
    },
  };
}
